<script lang="ts" setup>
import type { IBreadcrumbs } from "~/shared/interfaces/ui/breadcrumbs";

interface ICrumb {
  path: string
  name: string
}

interface IItemListElement {
  '@type': 'ListItem'
    position: number
    item: {
      '@id': string
      name: string
  }
}

const props = defineProps<{
  breadcrumbs: IBreadcrumbs[]
}>()

const getBreadcrumbsList = computed(() => {
  let slugsPath = ''
  if(props.breadcrumbs) return props.breadcrumbs.reduce<ICrumb[]>((acc, {slug, name}) => {
    slugsPath += `/${slug}`

    acc.push({
      name,
      path: slugsPath,
    })

    return acc;
  }, [])
})

const itemListElement:IItemListElement[] = []

if (props.breadcrumbs) {
  let urlId = `${useRequestURL().origin}`
  props.breadcrumbs.forEach((el, i) => {
    urlId += `/${el.slug}`
    let listItem:IItemListElement = {
      '@type': 'ListItem',
      position: i + 1,
      item: {
        '@id': `${urlId}`,
        name: el.name
      }
    }
    itemListElement.push(listItem)
  })
}


useJsonld({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: itemListElement
}, {tagPosition: "head"});



</script>

<template>
  <div class="breadcrumbs container">
    <ul class="breadcrumbs__list">
      <li
        class="breadcrumbs__list-item"
      >
        <NuxtLink
          to="/"
        >
          Главная
        </NuxtLink>
      </li>
      <li
        class="breadcrumbs__list-item"
        v-for="({ path, name }, index) in getBreadcrumbsList"
        :key="path"
      >
          <NuxtLink
            v-if="index !== breadcrumbs.length - 1"
            :to="path"
          >
            {{ name }}
          </NuxtLink>
          <div
            v-else-if="index === breadcrumbs.length - 1"
          >
            {{ name }}
          </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@-moz-document url-prefix() {
  .search-filter__body-container {
    scrollbar-width: none;
  }
}
.breadcrumbs {
  padding-top: 20px;
  background-color: $bg_page;
  @include md-breakpoint {
    padding-top: 20px;
    padding-bottom: 40px;
    overflow: auto;
  }

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
    background-color: $content_white;
  }

  &__list {
    display: flex;
    gap: 23px;
    @include font(14px, 20px);
    @include md-breakpoint {
      flex-wrap: nowrap;
    }

    &-item {
      white-space: nowrap;

      &:last-child {
        @include md-breakpoint {
          padding-right: 20px;
        }
      }
    }

    a, div {
      color: $control-content_secondary;
    }

    a {
      position: relative;

      &:hover:not(:active) {
        @include mf-breakpoint {
          color: $control-content_primary;
        }
      }

      &:after {
        content: '';
        width: 10px;
        height: 2px;
        border-radius: 1px;
        background-color: $content_icons;
        display: block;
        position: absolute;
        left: calc(100% + 7px);
        top: calc(50% - 2px);
      }
    }
  }
}
</style>
